export default {
  socialIdpUserId: {
    id: 'socialIdpUserId',
    displayName: 'Username',
    dataType: 'string',
    userInputType: 'TextBox',
    userHelpText: '',
    adminHelpText: '',
  },
  objectId: {
    id: 'objectId',
    displayName: "User's Object ID",
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Object identifier (ID) of the user object in Azure AD.',
    adminHelpText: '',
  },
  password: {
    id: 'password',
    displayName: 'Password',
    dataType: 'string',
    userInputType: 'Password',
    userHelpText: 'Enter password',
    adminHelpText: '',
    options: [],
    length: [0, 0],
  },
  tenantId: {
    id: 'tenantId',
    displayName: "User's Object's Tenant ID",
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Tenant identifier (ID) of the user object in Azure AD.',
    adminHelpText: '',
  },
  signInName: {
    id: 'signInName',
    displayName: 'Sign in name',
    dataType: 'string',
    userInputType: 'TextBox',
    userHelpText: '',
    adminHelpText: '',
  },
  accountEnabled: {
    id: 'accountEnabled',
    displayName: 'Account Enabled',
    dataType: 'boolean',
    userInputType: '',
    userHelpText: 'Specifies whether your account is enabled.',
    adminHelpText: "Specifies whether the user's account is enabled.",
  },
  foreignId: {
    id: 'foreignId',
    displayName: 'foreignId',
    dataType: 'userIdentity',
    userInputType: '',
    userHelpText: 'Used for social providers',
    adminHelpText: '',
  },
  passwordPolicies: {
    id: 'passwordPolicies',
    displayName: 'Password Policies',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Password policies used by Azure AD to determine password strength, expiry etc.',
    adminHelpText: '',
  },
  client_id: {
    id: 'client_id',
    displayName: 'client_id',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Special parameter passed to EvoSTS.',
    adminHelpText: 'Special parameter passed to EvoSTS.',
  },
  resource_id: {
    id: 'resource_id',
    displayName: 'resource_id',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Special parameter passed to EvoSTS.',
    adminHelpText: 'Special parameter passed to EvoSTS.',
  },
  sub: {
    id: 'sub',
    displayName: 'Subject',
    dataType: 'string',
    userInputType: '',
    userHelpText: '',
    adminHelpText: '',
  },
  identityProvider: {
    id: 'identityProvider',
    displayName: 'Identity Provider',
    dataType: 'string',
    userInputType: '',
    userHelpText: '',
    adminHelpText: '',
  },
  displayName: {
    id: 'displayName',
    displayName: 'Display Name',
    dataType: 'string',
    userInputType: 'TextBox',
    userHelpText: 'Your display name.',
    adminHelpText: '',
  },
  email: {
    id: 'email',
    displayName: 'Email Address',
    dataType: 'string',
    userInputType: 'TextBox',
    userHelpText: 'Email address that can be used to contact you.',
    adminHelpText: '',
  },
  otherMails: {
    id: 'otherMails',
    displayName: 'Alternate Email Addresses',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Email addresses that can be used to contact the user.',
    adminHelpText: '',
  },
  userPrincipalName: {
    id: 'userPrincipalName',
    displayName: 'UserPrincipalName',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Your user name as stored in the Azure Active Directory.',
    adminHelpText: '',
  },
  upnUserName: {
    id: 'upnUserName',
    displayName: 'UPN User Name',
    dataType: 'string',
    userInputType: 'TextBox',
    userHelpText: 'The user name for creating user principal name.',
    adminHelpText: '',
  },
  newUser: {
    id: 'newUser',
    displayName: 'User is new',
    dataType: 'boolean',
    userInputType: '',
    userHelpText: '',
    adminHelpText: '',
  },
  executedSelfAssertedInput: {
    id: 'executedSelfAssertedInput',
    displayName: 'executed-SelfAsserted-Input',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'A claim that specifies whether attributes were collected from the user.',
    adminHelpText: '',
  },
  authenticationSource: {
    id: 'authenticationSource',
    displayName: 'AuthenticationSource',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Specifies whether the user was authenticated at Social IDP or local account.',
    adminHelpText: '',
  },
  nca: {
    id: 'nca',
    displayName: 'nca',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Special parameter passed for local account authentication to login.microsoftonline.com.',
    adminHelpText: '',
  },
  grant_type: {
    id: 'grant_type',
    displayName: 'grant_type',
    dataType: 'string',
    userInputType: '',
    userHelpText: 'Special parameter passed for local account authentication to login.microsoftonline.com.',
    adminHelpText: '',
  },
  scope: {
    id: 'scope',
    displayName: 'scope',
    dataType: 'string',
    userInputType: 'TextBox',
    userHelpText: 'Special parameter passed for local account authentication to login.microsoftonline.com.',
    adminHelpText: '',
  },
  objectIdFromSession: {
    id: 'objectIdFromSession',
    displayName: 'objectIdFromSession',
    dataType: 'boolean',
    userInputType: '',
    userHelpText:
      'Parameter provided by the default session management provider to indicate that the object id has been retrieved from an SSO session.',
    adminHelpText: '',
  },
  isActiveMFASession: {
    id: 'isActiveMFASession',
    displayName: 'isActiveMFASession',
    dataType: 'boolean',
    userInputType: '',
    userHelpText:
      'Parameter provided by the MFA session management to indicate that the user has an active MFA session.',
    adminHelpText: '',
  },
  givenName: {
    id: 'givenName',
    displayName: 'Given Name',
    dataType: 'string',
    userInputType: 'TextBox',
    userHelpText: 'Your given name (also known as first name).',
    adminHelpText: '',
  },
  surname: {
    id: 'surname',
    displayName: 'Surname',
    dataType: 'string',
    userInputType: 'TextBox',
    userHelpText: 'Your surname (also known as family name or last name).',
    adminHelpText: '',
  },
  strongAuthenticationPhoneNumber: {
    id: 'strongAuthenticationPhoneNumber',
    displayName: 'Phone Number',
    dataType: 'string',
    mask: {
      type: 'Regex',
      value: 'XXX-XXX-',
      regex: '.+(?=.{4}$)',
    },
  },
  newNumberEntered: {
    id: 'newNumberEntered',
    displayName: 'New Phone Number Entered',
    dataType: 'boolean',
  },
};
